import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { Cookies } from "react-cookie";
import Snackbar from "../components/snackbar";
import NotifySnackbar from "../components/notifySnackbar";
import Booking from "../components/booking";
import Post from "../components/post";
import Cost from "../components/cost";
import Customers from "../components/customer";
import Dashboard from "../components/dashboard";
import DashboardAdmin from "../components/dashboard/admin";
import Discount from "../components/discount";
import Employees from "../components/employees";
import EditEmployee from "../components/employees/listEmployee/editEmployee/editContent";
import InviteEmployee from "../components/employees/addEmployee";
import Header from "../components/header";
import ServiceMenu from "../components/menu";
import ServiceOrders from "../components/orders/listOrder";
import DetailOrder from "../components/orders/detailOrder";
import Profile from "../components/profile";
import Report from "../components/report";
import SMS from "../components/sms";
import SendSMS from "../components/sms/send";
import Notification from "../components/notification";
import NotificationTemplate from "../components/notification/template";
import NotificationSend from "../components/notification/send";
import ServiceOwner from "../components/service/ownerSpa/index";
import ServiceAlbum from "../components/service/ownerSpa/serviceAlbum";
import ServiceStorage from "../components/storage";
import ServiceBranch from "../components/serviceBranch";
import Sidebar from "../components/sidebar";
import StableCost from "../components/stableCost";
import Users from "../components/user";
import Voucher from "../components/voucher";
import UserVoucher from "../components/userVoucher";
import MemberCard from "../components/memberCard";
import Module from "../components/module";
import ServiceContact from "../components/serviceContact";
import Visitor from "../components/visitor";
import Campaign from "../components/campaign";
import CustomerReport from "../components/customer/customerReport";
import { styles } from "./styles";
import NPS from "../components/nps";
import Payment from "../components/payment";
import UserMemberCard from "../components/userMemberCard/list";
import DetailUserMemberCard from "../components/userMemberCard/detail";
import Extend from "../components/extend";
import ServiceAdmin from "./adminService";
import SettingSystem from "../components/settingSystem";
import ProductMenuCreate from "../components/productMenu/create";
import ProductMenuList from "../components/productMenu/list";
import ProductCategory from "../components/productCategory";
import ProductCategoryCreate from "../components/productCategory/create";
import ProductMenuEdit from "../components/productMenu/edit";
import PluginCategory from "../components/pluginCategory";
import PluginCategoryCreate from "../components/pluginCategory/create";
import PluginCategoryOwner from "../components/pluginCategory/owner";
import PluginOwner from "../components/pluginCategory/owner/detail";
import PluginService from "../components/pluginService";
import DeveloperAccount from "../components/developerAccount/list";
import DeveloperAccountCreate from "../components/developerAccount/create";
import DigitalSignal from "../components/digitalSignal/list";
import DigitalSignalCreate from "../components/digitalSignal/create";
import Loading from "../components/loading";
import CustomerFeedback from "../components/customerFeedback";
import { _firebase, requestPermission, getToken } from "../utils/firebase";
import "@firebase/messaging";
const cookie = new Cookies();

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }
  handleDrawer = () => {
    this.setState({ ...this.state, ...{ open: !this.state.open } });
  };
  async componentWillMount() {
    await this.props.reLogin({
      push: this.props.history.push,
      snackbar: this.snackbar,
    });
    await this.props.getModuleRoleForWeb();
    await this.props.getPluginsForSpa();
    await this.props.getIpAddress();
  }
  async componentDidMount() {
    const { t } = this.props;

    this.loading.startLoading();
    let check = false;
    try {
      check = await this.props.checkLogin();
    } catch (error) {
      check = false;
    }
    this.loading.stopLoading();
    if (!check) {
      return this.props.history.push(`/signin`);
    }
    await this.props.getSettings();
    if (this.props.role !== "admin") this.props.getServiceSetting();

    const { stateLogin, loginAdmin } = this.props;
    if (!stateLogin || !loginAdmin) {
      this.props.disconnectFCM(cookie.get(Token));
      return;
    }
    const isRequestedPermission = await requestPermission();
    if (!isRequestedPermission) {
      return;
    }
    const fcmToken = await getToken();
    if (!fcmToken) {
      return;
    }

    this.props.saveFcmToken({
      fcmToken: fcmToken,
      typeDevice: "web",
    });
  }
  snackbar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };
  handleSelected = (selected) => {
    this.sidebar.handleSelected(selected);
  };
  render() {
    const { classes, t, role, ...props } = this.props;
    const { open } = this.state;
    return (
      <div className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <NotifySnackbar
          onRef={(snackbar) => (this.NotifySnackbar = snackbar)}
        />
        <Header
          open={open}
          handleSelected={this.handleSelected}
          handleDrawer={this.handleDrawer}
          {...props}
        />
        <Sidebar
          open={open}
          handleDrawer={this.handleDrawer}
          {...props}
          onRef={(id) => (this.sidebar = id)}
        />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {role === "admin" || role === "employeeAdmin" ? (
            <Switch>
              <Route
                path="/profile"
                render={(props) => <Profile {...props} />}
              />
              <Route path="/user" render={(props) => <Users {...props} />} />
              <Route
                path="/settingSystem"
                render={(props) => <SettingSystem {...props} />}
              />
              <Route
                path="/service-admin"
                render={(props) => <ServiceAdmin {...props} />}
              />
              <Route
                path="/pluginCategory/create"
                render={(props) => <PluginCategoryCreate {...props} />}
              />
              <Route
                path="/pluginCategory"
                render={(props) => <PluginCategory {...props} />}
              />
              <Route
                path="/developerAccount/create"
                render={(props) => <DeveloperAccountCreate {...props} />}
              />
              <Route
                path="/developerAccount"
                render={(props) => <DeveloperAccount {...props} />}
              />
              <Route
                path="/sms/send"
                render={(props) => <SendSMS {...props} />}
              />
              <Route path="/sms" render={(props) => <SMS {...props} />} />
              <Route
                path="/notification/template"
                render={(props) => <NotificationTemplate {...props} />}
              />
              <Route
                path="/notification/send"
                render={(props) => <NotificationSend {...props} />}
              />
              <Route
                path="/notification"
                render={(props) => <Notification {...props} />}
              />
              <Route
                path="/"
                render={(props) => <DashboardAdmin {...props} />}
              />
            </Switch>
          ) : role === "ownerSpa" || role === "employeeSpa" ? (
            <Switch>
              <Route
                path="/pluginCategory/:id"
                render={(props) => <PluginCategoryOwner {...props} />}
              />
              <Route
                path="/pluginCategory"
                render={(props) => <PluginCategoryOwner {...props} />}
              />
              <Route
                path="/plugin/:pluginKey"
                render={(props) => <PluginOwner {...props} />}
              />
              <Route
                path="/myPlugin/:pluginKey"
                render={(props) => <PluginService {...props} />}
              />
              <Route
                path="/module/extend"
                render={(props) => <Extend {...props} />}
              />
              <Route path="/module" render={(props) => <Module {...props} />} />
              <Route
                path="/profile"
                render={(props) => <Profile {...props} />}
              />
              <Route
                path="/booking"
                render={(props) => <Booking {...props} />}
              />
              <Route path="/report" render={(props) => <Report {...props} />} />
              <Route
                path="/sms/send"
                render={(props) => <SendSMS {...props} />}
              />
              <Route path="/sms" render={(props) => <SMS {...props} />} />
              <Route
                path="/notification/template"
                render={(props) => <NotificationTemplate {...props} />}
              />
              <Route
                path="/notification/send"
                render={(props) => <NotificationSend {...props} />}
              />
              <Route
                path="/notification"
                render={(props) => <Notification {...props} />}
              />

              <Route
                path="/serviceMenu"
                render={(props) => <ServiceMenu {...props} />}
              />
              <Route
                path="/productMenu/list"
                render={(props) => <ProductMenuList {...props} />}
              />
              <Route
                path="/productMenu/create"
                render={(props) => <ProductMenuCreate {...props} />}
              />
              <Route
                path="/productMenu/edit/:id"
                render={(props) => <ProductMenuEdit {...props} />}
              />
              <Route
                path="/productMenu/category/create"
                render={(props) => <ProductCategoryCreate {...props} />}
              />
              <Route
                path="/productMenu/category"
                render={(props) => <ProductCategory {...props} />}
              />
              <Route
                path="/service/detail"
                render={(props) => <ServiceOwner {...props} />}
              />
              <Route
                path="/service/branch"
                render={(props) => <ServiceBranch {...props} />}
              />
              <Route
                path="/service/stableCost"
                render={(props) => <StableCost {...props} />}
              />
              <Route
                path="/service/cost"
                render={(props) => <Cost {...props} />}
              />
              <Route
                path="/service/album"
                render={(props) => <ServiceAlbum {...props} />}
              />
              <Route
                path="/service/payment"
                render={(props) => <Payment {...props} />}
              />
              <Route
                path="/service/storage"
                render={(props) => (
                  <ServiceStorage
                    {...props}
                    onRef={(id) => (this.ServiceStorage = id)}
                  />
                )}
              />
              <Route
                path="/promotion/discount"
                render={(props) => <Discount {...props} />}
              />
              <Route
                path="/promotion/voucher"
                render={(props) => <Voucher {...props} />}
              />
              <Route
                path="/promotion/userVoucher"
                render={(props) => <UserVoucher {...props} />}
              />
              <Route
                path="/promotion/membercard"
                render={(props) => <MemberCard {...props} />}
              />
              <Route
                path="/promotion/userMembercard/detail"
                render={(props) => <DetailUserMemberCard {...props} />}
              />
              <Route
                path="/promotion/userMembercard/list"
                render={(props) => <UserMemberCard {...props} />}
              />
              <Route
                path="/order/detail/:_id"
                render={(props) => <DetailOrder {...props} />}
              />
              <Route
                path="/order/list"
                render={(props) => <ServiceOrders {...props} />}
              />
              <Route
                path="/employee/edit/:_id"
                render={(props) => <EditEmployee {...props} />}
              />
              <Route
                path="/employee/invite"
                render={(props) => <InviteEmployee {...props} />}
              />
              <Route
                path="/employee"
                render={(props) => <Employees {...props} />}
              />
              <Route
                path="/customer/:id"
                render={(props) => <CustomerReport {...props} />}
              />
              <Route
                path="/customer"
                render={(props) => <Customers {...props} />}
              />
              <Route path="/post" render={(props) => <Post {...props} />} />
              <Route
                path="/visitor"
                render={(props) => <Visitor {...props} />}
              />
              <Route
                path="/contact"
                render={(props) => <ServiceContact {...props} />}
              />
              <Route
                path="/campaign"
                render={(props) => <Campaign {...props} />}
              />
              <Route
                path="/digital/list"
                render={(props) => <DigitalSignal {...props} />}
              />
              <Route
                path="/digital/create"
                render={(props) => <DigitalSignalCreate {...props} />}
              />
              <Route path="/nps" render={(props) => <NPS {...props} />} />
              <Route
                path="/customerFeedback"
                render={(props) => <CustomerFeedback {...props} />}
              />
              {/* <Route path="/paymentReturn" render={props => <PaymentReturn {...props} />} /> */}
              <Route path="/" render={(props) => <Dashboard {...props} />} />
              <Route render={(props) => <div>{"404 Not Found"}</div>} />
            </Switch>
          ) : (
            ""
          )}
        </main>
      </div>
    );
  }
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  stateLogin: state.user.stateLogin,
  loginAdmin: state.user.user.roleId.loginAdmin,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  saveFcmToken: dispatch.fcm.saveFcmToken,
  getDistrict: dispatch.district.getDistrict,
  getSettings: dispatch.setting.getSettings,
  getServiceSetting: dispatch.serviceSetting.getServiceSetting,
  disconnectFCM: dispatch.fcm.disconnectFCM,
  reLogin: dispatch.user.reLogin,
  checkLogin: dispatch.user.set,
  getModuleRoleForWeb: dispatch.user.getModuleRoleForWeb,
  getIpAddress: dispatch.setting.getIpAddress,
  getPluginsForSpa: dispatch.pluginServices.getPluginsForSpa,
  connectSocket: dispatch.socketClient.connect,
});

export default translate("translations")(
  withStyles(styles, { withTheme: true })(connect(mapState, mapDispatch)(Main))
);
